import { render, staticRenderFns } from "./AssetDynamicDetails.vue?vue&type=template&id=1295a6ea&scoped=true&"
import script from "./AssetDynamicDetails.vue?vue&type=script&lang=js&"
export * from "./AssetDynamicDetails.vue?vue&type=script&lang=js&"
import style0 from "./AssetDynamicDetails.vue?vue&type=style&index=0&id=1295a6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295a6ea",
  null
  
)

export default component.exports